module.exports = __webpack_public_path__ + "media/images/area/area_yamanashiM400-6a80a7f476d8130a37d12bd3b948fea0.jpg";